import axios from "axios";
import fechaHoraActual from "./FechaHoraActual";
import MP_payerData from "../types/MP_payerData";
import MP_paymentData from "../types/MP_paymentData";

//import guardarTransaccion from "./guardarTransaccion";

export default async function PagoMP(pagador: MP_payerData, pago: MP_paymentData) {

    const url = "https://endpoints.mapsys.com.ar/pagos/payment";
    
    // Obtengo la fecha en formato ISO 8601
    const fechaActual = new Date().toISOString();
    
    // Creo un identificador único para la transacción (externalReference)
    const externalReference = "VPAW-" + pagador.titular + "-" + fechaActual.slice(0, 19);
    
    const data = {
        customer: {
            email: pagador.payerEmail,
            first_name: pagador.payerFirstName,
            last_name: pagador.payerLastName,
            identification: {
                type: pagador.payerIdentificationType,
                number: pagador.payerIdentificationNumber
            }
        },
        payment: {
            back_url: "https://www.vidaplus.com.ar/suscripcion_exitosa",
            external_reference: externalReference,
            card_token_id: pago.cardToken,
            payment_method_id: pago.paymentMethodId,
            installments: 1,
            transaction_amount: pago.transactionAmount,
            statement_descriptor: "VidaPlus",
            description: "VidaPlus Alta Web"
        }
    };
    
    try {
        const response = await axios.post(url, data);
        return response.data;
    } catch (error) {
        return error;
    }
};
